import styled from "styled-components";

export const FallbackHeaderBackground = styled.header`
  display: flex;
  height: 10vh;
  background: #002f56;
  padding: 1rem;
`;

export const FallbackHeaderLogo = styled.img`
  vertical-align: middle;
`;
